import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2f587f89"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "SeesawQuestionViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "跷跷板", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://cdn.waityou.online/90ccbffc-d1f3-a986-44e3-368a714a779f.xlsx",
  class: "ft14 ml16",
  style: {
    "color": "#1388ff"
  },
  target: "_blank"
}, [/*#__PURE__*/_createElementVNode("span", null, "下载题目模板")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14 ml16 mr4"
}, "题目数量:", -1));
const _hoisted_5 = {
  class: "ft14",
  style: {
    "color": "#1388ff"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "lightcoral"
  },
  class: "ft12 ptr"
}, "删除组", -1));
const _hoisted_7 = {
  class: "mr16"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14 ptr",
  style: {
    "color": "orangered"
  }
}, "删除", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "A", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "B", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "C", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftGroupList = _resolveComponent("LeftGroupList");
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_SeesawImage = _resolveComponent("SeesawImage");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "wbg flex flex-col wd100",
      style: {
        "height": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_LeftGroupList, {
        "group-title": "跷跷板分组",
        data: $data.groups,
        onChoose: $options.onChoose
      }, null, 8, ["data", "onChoose"]), _createVNode(_component_el_row, {
        class: "pd12"
      }, {
        default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
          "btn-id": 11,
          "btn-name": "+ 新增分组",
          style: 1,
          size: "small",
          onFresh: $options.init
        }, null, 8, ["onFresh"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "opd12 flex flex-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "pd12 wbg flex items-center"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 20,
          class: "flex items-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_ButtonDialog, {
            "btn-id": 12,
            "btn-name": "上传题目",
            "init-data": {
              'groupId': $data.groupId
            },
            onFresh: $options.fetchList
          }, null, 8, ["init-data", "onFresh"]), _hoisted_3, _hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString($data.questions.length), 1)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4,
          class: "flex justify-end items-center"
        }, {
          default: _withCtx(() => [$data.groupId != null && $data.groupId > 0 ? (_openBlock(), _createBlock(_component_el_popconfirm, {
            key: 0,
            title: "组内的题目也会一起删除，确定吗",
            onConfirm: $options.deleteGroup
          }, {
            reference: _withCtx(() => [_hoisted_6]),
            _: 1
          }, 8, ["onConfirm"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, (q, qi) => {
        return _openBlock(), _createBlock(_component_el_row, {
          key: q.id,
          class: "wbg mt12 pd12 flex flex-col",
          style: {
            "border": "#1388ff 1px dashed"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "ft14"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_7, "第" + _toDisplayString(qi + 1) + "题 ", 1), $data.groupId != null && $data.groupId > 0 ? (_openBlock(), _createBlock(_component_el_popconfirm, {
              key: 0,
              title: "确定删除吗",
              onConfirm: $event => $options.deleteSeesawQuestion(q.id)
            }, {
              reference: _withCtx(() => [_hoisted_8]),
              _: 2
            }, 1032, ["onConfirm"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.questions, (q, qi) => {
              return _openBlock(), _createBlock(_component_SeesawImage, {
                key: `sq_${qi}`,
                data: q
              }, null, 8, ["data"]);
            }), 128))]),
            _: 2
          }, 1024), _createVNode(_component_el_row, {
            style: {
              "align-items": "flex-end"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "flex flex-col flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_SeesawImage, {
                data: q.optionA
              }, null, 8, ["data"]), _hoisted_9]),
              _: 2
            }, 1024), _createVNode(_component_el_row, {
              class: "flex flex-col flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_SeesawImage, {
                data: q.optionB
              }, null, 8, ["data"]), _hoisted_10]),
              _: 2
            }, 1024), _createVNode(_component_el_row, {
              class: "flex flex-col flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_SeesawImage, {
                data: q.optionC
              }, null, 8, ["data"]), _hoisted_11]),
              _: 2
            }, 1024), _createVNode(_component_el_row, {
              class: "flex flex-col flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_SeesawImage, {
                data: q.optionD
              }, null, 8, ["data"]), _hoisted_12]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createElementVNode("span", null, "答案：" + _toDisplayString(q.rightAnswer), 1)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  })]);
}